import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { MultisiteService } from '@df/core/service/multisite';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NMultisiteGeolocationModal } from './multisite-geolocation-modal.interfaces';

@Injectable({
    providedIn: 'root'
})
export class MultisiteGeolocationInitiatorService extends AbstractDfModalInitiatorService<NMultisiteGeolocationModal.IInitiatorData> {
    constructor(
        dfModalService: DfModalService,
        app: App,
        private multisiteService: MultisiteService,
        private iCmsBlockResource: ICmsBlockResource
    ) {
        super(dfModalService, app);
    }

    listen(cb: (data: NMultisiteGeolocationModal.IInitiatorData) => void): Promise<void> {
        return new Promise(resolve => {
            if (!this.multisiteService.hasPreferredStore()) {
                this.iCmsBlockResource
                    .retrieve({ bareUrl: NMultisiteGeolocationModal.componentId }, undefined)
                    .then((block: NMultisiteGeolocationModal.Block | void) => {
                        if (block) {
                            this.app.customer.model
                                .load()
                                .then(a => {
                                    const geo = a.data.geo;

                                    if (geo) {
                                        if (
                                            (block.data?.content as NMultisiteGeolocationModal.IBlockDataContent).variants.find(
                                                store =>
                                                    store.countries
                                                        ?.toUpperCase()
                                                        .split(',')
                                                        .find(i => i.trim() === geo)
                                            )
                                        ) {
                                            cb({ matchingCountry: geo });
                                        }
                                    }
                                })
                                .finally(() => resolve());
                        } else {
                            resolve();
                        }
                    })
                    .catch(() => resolve());
            } else {
                resolve();
            }
        });
    }
}
